var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KeyFinanceRatio',{attrs:{"mode":"pdf","node":_vm.node}})
}
var staticRenderFns = []

export { render, staticRenderFns }